export const UPDATE_STATUS_FAILED_MESSAGE = "error:operator.update-status-failed"
export const GET_STATUS_FAILED_MESSAGE = "error:operator.get-status-failed"
export const CONNECTED_FAILED_MESSAGE = "error:operator.connected-failed"
export const DISCONNECT_HUB_FAILED_MESSAGE = "error:operator.disconnect-failed"
